import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import vars, { typography } from 'li-components/lib/styles'
import Button from 'li-components/lib/next/Button'
import TargetBlank from 'li-components/lib/TargetBlank'
import config from '../config'
import { getAppDotOrigin, isAuthorized } from '../util'

export const Container = styled.div`
  width: 60%;
  padding: 2rem 3rem;
  margin: 4rem auto;
  border: 1px solid ${vars.inputBorderColor};
  border-radius: ${vars.inputBorderRadius};
  font-size: ${vars.bodyBaseFontSize};
  text-align: center;
  transition: height 1s;

  @media screen and (max-width: ${vars.screenMd}) {
    width: 75%;
  }

  @media screen and (max-width: ${vars.screenSm}) {
    width: 90%;
  }

  p {
    ${typography.p};
    margin: 2rem 0;
  }

  h1 {
    ${typography.h1};
  }
`

const SupportLink = styled(TargetBlank)`
  display: block;
  margin: 2rem auto;
  color: ${vars.brandPrimary};
`

const origin = getAppDotOrigin()

const mapStateToProps = state => ({
  user: state.auth.user,
})

const AccessRestricted = ({ user }, { appId }) => {
  const appConfig = config.applicationConfigurations[appId]
  const gotoApp = isAuthorized(user.organizationDefaultApplication, user)
    ? user.organizationDefaultApplication
    : 'onboard'

  return (
    <Container>
      <div>
        <h1>ACCESS RESTRICTED</h1>
        <p>{appConfig.marketingDescription}</p>
        <SupportLink
          href={
            appConfig.marketingLink ||
            config.applicationConfigurations.default.marketingLink
          }
        >
          Learn More
        </SupportLink>
        <a href={`${origin}/${user.organizationDefaultApplication}`}>
          <Button kind="primary" size="large">
            go to {gotoApp}
          </Button>
        </a>
      </div>
    </Container>
  )
}

AccessRestricted.propTypes = {
  user: PropTypes.object.isRequired,
}

AccessRestricted.contextTypes = {
  appId: PropTypes.string.isRequired,
}

export default connect(mapStateToProps)(AccessRestricted)



// WEBPACK FOOTER //
// ./~/label-insight-app-shell/src/Application/components/AccessRestricted.js